export const links = [
    { title: 'Download The App', url: '//bnc.lt/61Rm/pcKcpUc7Us' },
    { title: 'Community Guidelines', url: '//www.mutual.app/standards' },
    { title: 'Terms and Conditions', url: '//www.mutual.app/standards' },
    { title: 'FAQs', url: 'https://support.mutual.app/collection/9-faq/' },
    { title: 'Mutual Blog', url: '//blog.mutual.app' },
    { title: 'Success Stories', url: '//blog.mutual.app/category/success-stories/' },
    { title: 'Dating Tips', url: '//blog.mutual.app/category/dating/' },
]
